import Header from './components/Header'
import Projects from './components/Projects'
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Highlight from './components/Highlight'
import { useState, useRef } from 'react'
import { translations } from './components/data/lang/translations'
import { debounce } from 'lodash';

function App() {

  const [showNav, setShowNav] = useState(false);
  const [locale, setLocale] = useState('en');

  const navbarClick = () => { //Currently not in use (28 April 2026)
    setShowNav(!showNav);
    console.log(showNav)
  }

// Start scripts for translation function
  const updateButtonStyle = (l) => {
    const spanEN = document.querySelector('#locale-en')
    const spanFR = document.querySelector('#locale-fr')

    if (l === 'en') {
      spanEN.classList.add('header-locale-current')
      spanFR.classList.remove('header-locale-current')
    }
    else {
      spanEN.classList.remove('header-locale-current')
      spanFR.classList.add('header-locale-current')
    }
  }

  function translateElementInitial(element) { //This function is ONLY called the first time the app loads by the following event listener
    const key = element.getAttribute("data-i18n-key");
    const translation = translations[locale][key];
    element.innerText = translation;
    updateButtonStyle(locale)
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-i18n-key]").forEach(translateElementInitial);
  });

  const translateElements = (nextLocale) => { //This function is not called directly, it is called by the following debounce function
    document.querySelectorAll("[data-i18n-key]").forEach((e) => {
      const key = e.getAttribute('data-i18n-key');
      const translation = translations[nextLocale][key];
      e.innerText = translation;
    })
    setLocale(nextLocale)
    updateButtonStyle(nextLocale)
  }

  const debounceTranslation = useRef(debounce(l => translateElements(l), 500, {leading: true, trailing: false})).current

  const changeLocale = () => {
    var nextLocale = ''
    if (locale === 'en') {
      nextLocale = 'fr';
    }
    else {nextLocale = 'en'}
    debounceTranslation(nextLocale)
    }

  const translateOnRefresh = () => { //This needs to passed on to each component
    translateElements(locale)
  }
//End scripts for translation function

  return (
  <Router   future={{
    v7_startTransition: true,
    v7_relativeSplatPath: true,
  }}>
    <div className="App">
    <Header navbarClick={navbarClick} showNav={showNav} currentLocale={locale} localeChange={changeLocale} />
    <Routes>
      <Route path='/' element={<><Projects /></>}/>
      <Route path='/highlight' element={<><Highlight translate={translateOnRefresh}/></>}/>
    </Routes>
    </div>
  </Router>
  );
}

export default App;
